import React from 'react';

import { Tab } from 'rbx';

import {
  Tabs,
  // InputErrorMessage,
} from '../../../components/elements';

const TabSection = ({ tab, setTab }) => (
  <Tabs className="tabs is-medium">
    <Tab active={tab === 0} onClick={() => setTab(0)}>
      Payment Policy
    </Tab>
    <Tab active={tab === 1} onClick={() => setTab(1)}>
      Payment Terms
    </Tab>
    <Tab active={tab === 2} onClick={() => setTab(2)}>
      Cancellation Policy
    </Tab>
    <Tab active={tab === 3} onClick={() => setTab(3)}>
      Cancellation Terms
    </Tab>
  </Tabs>
);

export default TabSection;
